module.exports = __webpack_public_path__ + "img/003.29b78239.webp";